import DayOfEventCard from './DayOfEventCard';

export default DayOfEventCard;
